<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Cj3yeF/media/FC-9781398446052.jpg?1692049837654" alt="This image is the cover for the book Mangrove Sands – The Enchanted Sea World"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mangrove Sands – The Enchanted Sea World
      </h1>
      <p class="bookDescription body article font2">
        <p>The Epic Journey is the third book of the Mangrove Sands series. It aims to inspire and educate children who for one reason or another have difficult starts in life, either by fate or disability. Based on an island in South East Queensland, Australia, five children experience many adventures and mishaps through an enchanted underwater sea world with their magical talking animal friends. A young Swedish girl has recently had her leg amputated. She struggles to accept the loss of her leg and has no interest in making new friends or attempting to walk until she meets her Enchanted Sea World friends and her life is changed forever. She starts doing things she never thought possible. She shows her friends how to make Dala horses, bake Swedish buns and join in traditional Swedish celebrations. Mangrove Sands, The Epic Journey is full of magical adventures in the Enchanted Sea World including surviving a cyclone, a pandemic, and the realm of horrors. Magical spoons, a magical sea god, a wedding, and a death will keep young minds curious and captivated. This book is full of fun, adventure, and many magical moments. It aims to provide hope and inspiration to children around the globe and encourages children to embrace, respect and learn about other cultures and languages. It further encourages children to exercise humility, love and understanding to all.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        L. J. Nilsson, Sallie-Anne Swift
      </h2>
      
      <p class="authorDescription body article">Born in 1962, Melbourne, Australia, the author has lived on a small island in South East Queensland, Australia since 2007. She studied and worked in Sweden for five years before returning to Australia with her two sons. She worked in media and charity before undertaking studies in social science and neuro-linguistic programming, becoming a qualified councillor and international life coach. She was awarded the Hazel Hawke Scholarship to study at Curtin University and went on to work with primary school students, mentoring and working primarily in areas of social skilling and behaviour. Inspired by her environment and her students, the author wrote the first book of the Mangrove Sands series after retirement in 2018. She self-published a book about her beloved canine, Sir Charles Barkley, who died in 2020, donating the proceeds from sales to WIRES animal rescue. The author continues to write children’s books at her peaceful island home in South East Queensland.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7012aaee